import React from 'react';
import { StyledTH } from './styles';

export type THProps = React.ThHTMLAttributes<HTMLTableCellElement>;

const TH: React.FC<THProps> = props => <StyledTH {...props} />;

export default TH;
